function getGlobalStates() {
    return {
        testStoryId: global.SHERLO_TEST_STORY_ID,
    };
}
export default getGlobalStates;
//# sourceMappingURL=getGlobalStates.js.map